import React, { useState, useEffect } from "react";
import useSupabaseBrowser from "../hooks/use-supabase-browser";
import { getValets } from "../api/get-valets";
import { getVenues } from "../api/get-venues";
import { Link } from "react-router-dom";

interface SearchResult {
  name: string;
  id: string;
  type: "valet" | "venue";
}

const Search: React.FC = () => {
  const supabaseClient = useSupabaseBrowser();
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.trim().toLowerCase();
    if (!query) {
      setSearchResults([]);
      return;
    }

    const valetsResponse = await getValets(
      supabaseClient,
      null,
      null,
      null,
      false,
      query
    );
    const venuesResponse = await getVenues(
      supabaseClient,
      null,
      null,
      null,
      false,
      query
    );

    if (valetsResponse.error || venuesResponse.error) {
      console.error(
        "Error during search:",
        valetsResponse.error || venuesResponse.error
      );
      setSearchResults([]);
      return;
    }

    const valetsData = valetsResponse.data || [];
    const venuesData = venuesResponse.data || [];

    const valetResults: SearchResult[] = valetsData.map((valet) => ({
      name: valet.full_name,
      id: valet.id,
      type: "valet",
    }));

    const venueResults: SearchResult[] = venuesData.map((venue) => ({
      name: venue.name,
      id: venue.id,
      type: "venue",
    }));

    const combinedResults: SearchResult[] = [...valetResults, ...venueResults];

    setSearchResults(combinedResults);
  };

  useEffect(() => {
    setShowDropdown(searchResults.length > 0);
  }, [searchResults]);

  const handleItemClick = () => {
    setShowDropdown(false);
  };

  return (
    <div className="dropdown dropdown-bottom dropdown-end">
      <input
        type="text"
        placeholder="Search"
        className="input input-sm rounded-full max-sm:w-fit"
        onChange={handleSearch}
        tabIndex={0}
      />

      {showDropdown && (
        <div
          className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-full min-w-fit lg:min-w-96 mt-4 absolute z-50"
          tabIndex={0}
        >
          {searchResults.some((result) => result.type === "valet") && (
            <div>
              <label className="menu-title">Valets</label>
              <ul>
                {searchResults
                  .filter((result) => result.type === "valet")
                  .map((valet, index) => (
                    <li key={index} className="menu-item">
                      <Link
                        to={`/valets/${valet.id}/edit`}
                        onClick={handleItemClick}
                      >
                        {valet.name}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          )}
          {searchResults.some((result) => result.type === "venue") && (
            <div>
              <label className="menu-title">Venues</label>
              <ul>
                {searchResults
                  .filter((result) => result.type === "venue")
                  .map((venue, index) => (
                    <li key={index} className="menu-item">
                      <Link
                        to={`/venues/${venue.id}/edit`}
                        onClick={handleItemClick}
                      >
                        {venue.name}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
